<template>
  <div>
    <div class="border-bottom font-weight-bold bg-light py-3 px-3">
      {{category.title}}
    </div>

    <div
      v-for="question in category.questions"
      :key="question.id"
      :question="question"
      class="border-bottom pl-5">
      <QuestionnaireQuestion
        :question="question"
        :mode="mode"
        :comment-answer="commentAnswer"
        :update-answer="updateAnswer"
        :userCanEdit="userCanEdit"
        :userCanComment="userCanComment" />
    </div>
  </div>
</template>

<script>
import QuestionnaireQuestion from './Question';

export default {
  name: 'QuestionnaireCategory',

  components: {QuestionnaireQuestion},

  props: ['category', 'mode', 'commentAnswer', 'updateAnswer', 'userCanEdit', 'userCanComment'],

  data() {
    return {};
  },
};
</script>
